// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Buefy from 'buefy';
import wysiwyg from "vue-wysiwyg";
import * as VeeValidate from 'vee-validate';
import PermissionModel from '@/model/permission_model';
import Permission from '@/plugins/permission';
import mStyle from '@/plugins/mixin_style';
import HighchartsVue from 'highcharts-vue'

import { SnackbarProgrammatic as Snackbar } from 'buefy'


Vue.use(wysiwyg, {}); // config is optional. more below
Vue.use(VeeValidate, {});
Vue.use(Permission, {});
Vue.use(mStyle, {});
Vue.use(HighchartsVue);
Vue.use(Snackbar);


Vue.use(Buefy, {  
  defaultIconPack: 'fas',
});


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  watch: {
    '$route': function (to, from) {
      if (this.$route.path == "/" || this.$route.path == "/logout" || this.$route.path == "/login") {
        return;
      }
      let permList = PermissionModel.get_my();
      permList.then((res) => {
        localStorage.permissions = res;
        let permissions = res;
        let filteredPermissions = [];

        if (permissions.includes("all")) {
          filteredPermissions.push("all");
        }

        if (to.meta.permissions) {
          if (permissions.includes("all")) {
            filteredPermissions.push("all");
          }else{
            filteredPermissions = permissions.filter((perm) => to.meta.permissions.includes(perm));
          }

          if (filteredPermissions && filteredPermissions.length < 1) {
            this.$router.push("/");
            this.$buefy.snackbar.open("คุณไม่มีสิทธ์ใช้งานส่วนนี้");
          }
        }


      });
    }
  },
  async beforeCreate(){
    if (this.$route.path == "/" || this.$route.path == "/logout" || this.$route.path == "/login") {
      return;
    }
    let permList = PermissionModel.get_my();
    permList.then((res) => {
      localStorage.permissions = res;
      let permissions = res;
      let filteredPermissions = [];

      if (this.$route.meta.permissions) {
        if (permissions.includes("all")) {
          filteredPermissions.push("all");
        }else{
          filteredPermissions = permissions.filter((perm) => this.$route.meta.permissions.includes(perm));
        }

        if (filteredPermissions && filteredPermissions.length < 1) {
          this.$router.push('/');
          this.$buefy.snackbar.open("คุณไม่มีสิทธ์ใช้งานส่วนนี้");
        }
      }
    });

  }
});



// WEBPACK FOOTER //
// ./src/main.js